module.exports = __webpack_public_path__ + "img/open_transparent_white.a9d2484b.svg";